import React from "react";
import { Progress } from "nq-component";
import withRouter from "../../../../withRouter";
import NavBar from "../../../../components/navbar";
import BasePage from "../../../../base/BasePage";
import { findObjectUseCase } from "../../../../usecases/object";

class JobViewPage extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      objects: [],
    };
  }

  getCollectionName() {
    return "job_posting";
  }

  componentDidMount() {
    this.getJobDetails();
  }

  async getJobDetails() {
    const params = this.getParams().id;
    const query = {
      where: {
        id: params,
      },
    };

    const response = await findObjectUseCase().execute("job_posting", query);
    this.setState({ objects: response });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects } = this.state;

    const job = objects[0];

    if (!schema) return <Progress />;
    const user = this.getCurrentUser();
    return (
      <>
        <NavBar user={user} />
        <div className="container m-4">
          {/* Job Title and Back Button */}
          <div className="d-flex align-items-center mb-4">
            <i
              className="bi bi-arrow-left me-2 fs-4 cursor-pointer"
              onClick={() => this.navigateBack()}
            ></i>
            <h3 className="fw-bold">{job?.positionTitle}</h3>
          </div>

          {/* Job Information */}
          <div className="d-flex">
            <div className="mb-4" style={{ fontSize: "13px" }}>
              <p>
                <strong>Date Posted:</strong>{" "}
                <span>
                  {new Date(job?.created).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </span>
              </p>
              <p>
                <strong>Deadline of Application:</strong>{" "}
                {new Date(job?.deadline).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
              <p>
                <strong>Slots available:</strong>{" "}
                <span className="text-success">{job?.slotVacancy} slots</span>
              </p>
            </div>

            {/* Job Description */}
            <div className="ms-4">
              <div className="mb-4  rounded" style={{ color: "#d18237" }}>
                <div className="d-flex align-items-center mb-2">
                  <i className="bi bi-info-circle fs-4 me-2"></i>
                  <h5 className=" fw-bold">Job Description</h5>
                </div>
                <p className="text-muted">{job?.jobDescription}</p>
              </div>

              {/* Qualification Standards */}
              <div className="mt-5 rounded" style={{ color: "#d18237" }}>
                <div className="d-flex align-items-center mb-2">
                  <i className="bi bi-briefcase fs-4 me-2"></i>
                  <h5 className="fw-bold">Qualification Standards</h5>
                </div>
                <p className="text-muted">{job?.qualificationStandard}</p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(JobViewPage);
